module.exports = __webpack_public_path__ + "static/media/image-choice-light-pink.1bcb1873.svg";